import { AlainMockConfig } from '@ihulk/util';

export const MOCK_DEFULAT_CONFIG: AlainMockConfig = {
  data: null,
  delay: 300,
  force: false,
  log: true,
  executeOtherInterceptors: true,
};
